import React from 'react';

const SvgTimeOutline = (props) => (
  <svg
    width={props?.width || '16'}
    height={props?.height || '16'}
    viewBox="0 0 16 16"
    {...props}
    fill={props?.color || 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00888 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0V0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.3536 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667V14.6667Z"
      fill="#333333"
    />
    <path
      d="M8.00013 4C7.82332 4 7.65375 4.07024 7.52872 4.19526C7.4037 4.32029 7.33346 4.48985 7.33346 4.66667V7.54999L5.08613 8.95799C4.93584 9.05188 4.829 9.20162 4.78912 9.37428C4.74923 9.54694 4.77957 9.72837 4.87346 9.87866C4.96735 10.0289 5.11709 10.1358 5.28975 10.1757C5.46241 10.2155 5.64384 10.1852 5.79413 10.0913L8.35413 8.49133C8.45085 8.43072 8.53039 8.3463 8.58514 8.24615C8.63989 8.14599 8.668 8.03346 8.66679 7.91933V4.66667C8.66679 4.48985 8.59656 4.32029 8.47153 4.19526C8.34651 4.07024 8.17694 4 8.00013 4Z"
      fill="#333333"
    />
  </svg>
);

export default SvgTimeOutline;
